<template>
  <div class="rtl-card">
    <div class="rtl-card-header">
      <span class="rtl-icon-pill">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18"/>
          <path d="M3 12h18"/>
          <path d="M3 18h18"/>
        </svg>
      </span>
      <div class="rtl-header-text">
        <h2 class="rtl-card-title">{{ tableTitle }}</h2>
        <p class="rtl-card-subtitle">{{ tableSubtitle }}</p>
      </div>
      <button class="rtl-clean-btn" @click="deleteLocationData">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18"/>
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
          <path d="M10 11v6M14 11v6"/>
        </svg>
        Delete Location Data
      </button>
    </div>

    <div v-if="tableData.length > 0" class="rtl-table-wrap">
      <v-table
        class="raceTable rtl-table"
        is-horizontal-resize
        :columns="columns"
        :table-data="tableData"
        :show-vertical-border="false"
        :title-bg-color="'#f8f8fc'"
        :title-row-height="38"
        :border="0"
        row-hover-color="#f8f7ff"
        :row-click="raceDetail"
      ></v-table>
    </div>

    <div v-else class="rtl-empty">
      <span class="rtl-empty-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9"/>
          <path d="M8 12h8"/>
          <path d="M12 8v8"/>
        </svg>
      </span>
      <p class="rtl-empty-title">{{ emptyTitle }}</p>
      <p class="rtl-empty-copy">{{ messageEmptyList || 'Try a different search or date filter.' }}</p>
    </div>
  </div>
</template>

<script>
import 'vue-easytable/libs/themes-base/index.css'
import {VTable, VPagination} from 'vue-easytable'
import Vue from "vue"
import moment from 'moment'
import {db, deleteLocationData} from '../../firebase'

Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
export default {
  name: 'race-table-list',
  data: () => ({
    pastRaces: [],
    tableData: [],
    columns: [],
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    totalRunner: null
  }),
  props: {
    races: {
      type: Array,
      required: true
    },
    messageEmptyList: {
      type: String,
      required: false
    },
    tableTitle: {
      type: String,
      required: false,
      default: 'Finished Runs'
    },
    tableSubtitle: {
      type: String,
      required: false,
      default: 'Review completed runs and open archived runner data'
    },
    emptyTitle: {
      type: String,
      required: false,
      default: 'No finished runs found'
    },
    dateField: {
      type: String,
      required: false,
      default: 'finishDate'
    },
    type: {
      type: String,
      required: false
    }
  },
  methods: {
    deleteLocationData() {
      //load top 100 records from locations from firebase
      var locationIds = db.ref("/locations/").limitToFirst(100);
      //for each location
      locationIds.once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          //if location has property procesed true then delete locationData node in location
          if (childSnapshot.val().processed) {
            db.ref("/locations/").child(childSnapshot.key).child("locationData").remove().then(r => {
              console.log("Node deleted >>>" + childSnapshot.key);
            });
          }
        });
      });

      // var id = 26892;
      // var runners = db.ref("/locations/").child(id).child("runners");
      // //for each runner
      // runners.once('value', function (snapshot) {
      //   snapshot.forEach(function (childSnapshot) {
      //     //if runnder has property procesed true then delete locationData node in runner
      //     if (childSnapshot.val().processed) {
      //       db.ref("/locations/").child(id).child("runners").child(childSnapshot.key).child("locationData").remove().then(r => {
      //         console.log("Node deleted >>>" + childSnapshot.key);
      //       });
      //     }
      //   });
      // });
    },
    getRacesInfo() {
      const pastRuns = this.races.map((race) => {
        let totalRunner = 0

        db.ref(`/${this.$fbDbEntry}/${race.id}/runners`)
          .on('value', (runnersFirebase) => {

            const runnersObject = runnersFirebase.val()

            if (runnersObject) {
              totalRunner = Object.keys(runnersObject).length
            }
          })

        return {
          id: race.id,
          imageUrl: race.imageUrl || race.image_url || race.ImageUrl || '',
          duration: race.duration,
          name: race.name,
          trainerName: race.trainer.firstName,
          date: moment(race[this.dateField]).format('YYYY/MM/DD'),
          day: this.weekdays[moment(race.date).day()],
          startTime: moment(race.startDate).format('h:mm A'),
          totalRunner: totalRunner
        }
      })
      pastRuns.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date)
      })

      this.tableData = pastRuns

      this.columns = [
        {field: "imageUrl", title: 'Image', width: 82, titleAlign: 'center', columnAlign: 'center', componentName: 'run-image-thumb'},
        {field: "id", title: 'Run ID', width: 80, titleAlign: 'center', columnAlign: 'center', componentName: 'run-id-link'},
        {field: "date", title: 'Date', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "day", title: 'Day', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "startTime", title: 'Start Time', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "name", title: 'Name', width: 190, titleAlign: 'center', columnAlign: 'center', isResize: true},
        {field: "duration", title: 'Duration min', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {field: "totalRunner", title: 'Total Runners', width: 100, titleAlign: 'center', columnAlign: 'center'},
        {
          field: "trainerName",
          title: 'Trainer',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center',
          isResize: true
        },
        {
          field: "action",
          title: 'Action',
          width: 100,
          titleAlign: 'center',
          columnAlign: 'center',
          componentName: 'view-run-link'
        }
      ]
    },
    raceDetail(newValue, raceData) {
      this.$router.push({
        name: 'past-run',
        params: {pastRun: true, raceId: raceData.id}
      })
    }
  },
  created() {
    this.getRacesInfo()
  },
  watch: {
    races() {
      this.getRacesInfo()
    }
  }
}

Vue.component('run-image-thumb', {
  template: `
    <div class="rtl-image-cell">
      <img
        v-if="showImage"
        :src="rowData.imageUrl"
        class="rtl-run-image"
        alt=""
        @error="showImage = false"
      >
      <span v-else class="rtl-run-image-placeholder">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <path d="M21 15l-5-5L5 21"/>
        </svg>
      </span>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      showImage: !!(this.rowData && this.rowData.imageUrl)
    }
  },
  watch: {
    rowData: {
      handler(newValue) {
        this.showImage = !!(newValue && newValue.imageUrl)
      },
      deep: true
    }
  }
})

Vue.component('view-run-link', {
  template: `
    <div class="rtl-link-wrap">
      <a 
        href="#" 
        @click.stop.prevent="viewRun()" 
        class="rtl-table-link"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
          <path d="M15 3h6v6"/>
          <path d="M10 14L21 3"/>
        </svg>
        View Run
      </a>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    viewRun() {
      const raceId = this.rowData.id
      const url = `${window.location.origin}/#/admin/live-run/race/${raceId}`
      window.open(url, '_blank')
    }
  }
})

Vue.component('run-id-link', {
  template: `
    <div class="rtl-link-wrap">
      <a
        href="#"
        class="rtl-table-link rtl-table-link--id"
        @click.stop.prevent="openPastRun()"
      >
        {{ rowData.id }}
      </a>
    </div>
  `,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    openPastRun() {
      const raceId = this.rowData.id
      const url = `${window.location.origin}/#/admin/past-run/detail/${raceId}`
      window.open(url, '_blank')
    }
  }
})
</script>
<style>
.rtl-card {
  border: 1px solid #e8e8ed;
  border-radius: 14px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  background: #fff;
  margin-bottom: 1.5rem;
}

.rtl-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 1.35rem;
}

.rtl-icon-pill {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.rtl-header-text {
  min-width: 0;
  margin-right: auto;
}

.rtl-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.2;
}

.rtl-card-subtitle {
  font-size: 12px;
  color: #8a8a9a;
  margin: 4px 0 0;
}

.rtl-clean-btn {
  height: 33px;
  border: 1.5px solid #5b4fcf;
  border-radius: 7px;
  background: #fff;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background .18s ease, color .18s ease, border-color .18s ease;
}

.rtl-clean-btn:hover {
  background: #f0effe;
  border-color: #4338ca;
  color: #4338ca;
}

.rtl-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #f0f0f5;
  border-radius: 10px;
}

.rtl-table {
  width: 100%;
  min-width: 940px;
}

.raceTable tr.v-table-row {
  cursor: pointer;
}

.raceTable .v-table-body-cell {
  color: #1a1a2e;
  font-size: 13px;
  border-color: #f0f0f5 !important;
}

.raceTable .v-table-row {
  height: 44px;
}

.raceTable th, 
.raceTable .v-table-header-cell,
.raceTable .v-table-header-column-text-inner,
.raceTable .v-table-header-row,
.raceTable .v-table-sort-icon {
  color: #1a1a2e !important;
  font-size: 12px;
  font-weight: 700;
  background: #f8f8fc !important;
  border-color: #f0f0f5 !important;
}

.rtl-link-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rtl-table-link {
  color: #5b4fcf;
  cursor: pointer;
  font-weight: 700;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  padding: 0 8px;
  border-radius: 7px;
  transition: background .18s ease, color .18s ease;
}

.rtl-table-link:hover {
  background: #f0effe;
  color: #4338ca;
}

.rtl-table-link--id {
  color: #413b94;
  background: #f8f7ff;
}

.rtl-image-cell {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rtl-run-image,
.rtl-run-image-placeholder {
  width: 52px;
  height: 34px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rtl-run-image {
  object-fit: cover;
  border: 1px solid #e8e8ed;
  background: #fafafa;
}

.rtl-run-image-placeholder {
  border: 1px dashed #d9d9e6;
  background: #f0effe;
  color: #5b4fcf;
}

.rtl-empty {
  min-height: 210px;
  border: 1px dashed #d9d9e6;
  border-radius: 10px;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1.75rem;
}

.rtl-empty-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.rtl-empty-title {
  color: #1a1a2e;
  font-size: 15px;
  font-weight: 700;
  margin: 0;
}

.rtl-empty-copy {
  color: #8a8a9a;
  font-size: 12px;
  margin: 5px 0 0;
}

@media (max-width: 680px) {
  .rtl-card {
    padding: 1.25rem;
  }

  .rtl-card-header {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .rtl-clean-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// RaceTableList.vue?6d67b140